<template>
  <transition name="el-zoom-in-top">
    <el-dialog title="编辑质检报告" :visible.sync="report.show" width="30%">
      <div style="text-align: left;" v-show="report.show">
        <div slot="header" class="clearfix"></div>
        <div v-show="show">
          <!-- 填写基础信息 -->
          <el-form
            ref="report"
            :model="report"
            label-width="120px"
            style="width:50%"
            :rules="rules"
          >
            <el-form-item label="上传图片">
              <el-upload
                ref="upload"
                :action="uploadurl"
                :headers="headers"
                list-type="picture-card"
                :on-success="qinchulist"
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove"
                 :before-upload="beforeAvatarUpload"
                :auto-upload="true"
                :file-list="fileList"
                :limit="1"
                :on-change="onchange"
                name="uploadFile"
              >
                <el-tooltip class="item" effect="dark" content="只能上传一张图片" placement="top">
                  <i class="el-icon-plus"></i>
                </el-tooltip>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="图片展开" />
              </el-dialog>
            </el-form-item>
          </el-form>
          <div style="text-align: center;">
            <el-button style="margin-top: 12px;" @click="submitadd('report')" type="primary">提交</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </transition>
</template>
<script>
import {
  qualityreports,
  qualityreportsupdate,
  uploadimg,
  downloadimg
} from "@/api/plant";
import { getToken } from '@/utils/auth'
export default {
  props: {
    search: {
      type: Function,
      default: null
    },
    report: {
      type: Object,
      default: () => {
        return {
          show: false,
          id: null,
          quality_reports: null
        };
      }
    }
  },
  data() {
    return {
      options: [
        {
          value: 0,
          label: "红包"
        }
      ],
      //基础数据
      show: true,
      active: 1,
      // 上传图片
      headers:{
        Token:getToken()
      },
      uploaddata: { folder: "xyq" },
      fileList: [],
      uploadurl:
        process.env.VUE_APP_BASE_API +
        "/api/produce/fileuploader/uploadimg",
      dialogVisible: false,
      dialogImageUrl: null,
      rules: {
        code: [{ required: true, message: "请输入奖品编码", trigger: "blur" }],
        name: [
          { required: true, message: "请输入奖品名称", trigger: "blur" },
          { min: 2, max: 20, message: "长度在 2 到 20 个字符", trigger: "blur" }
        ],
        value: [
          { required: true, message: "请输入奖励金额", trigger: "blur" },
          { type: "number", message: "必须为数字值" }
        ],
        sort: [
          { required: true, message: "请输入排序", trigger: "blur" },
          { type: "number", message: "必须为数字值" }
        ]
      }
    };
  },
  mounted() {},
  methods: {
    //保存提交
    submitadd(formName) {
      this.$refs[formName].validate(valid => {
        //基础表单验证
        if (valid) {
          // 上传图片
          if (!this.report.quality_reports) {
            this.$message({
              message: "请上传质检报告图片",
              type: "warning"
            });
            this.$refs.upload.submit();
          } else {
            qualityreportsupdate(this.report).then(response => {
              if (response.status_code == 200) {
                this.$message({
                  type: "success",
                  message: "提交成功!"
                });
                this.report.show = false;
                this.resetForm("report");
                this.search();
                this.report.show = false;
              } else {
                this.$message({
                  type: "warning",
                  message: "修改失败!请检查字段"
                });
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    // 清空表单数据
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$refs.upload.clearFiles();
    },
    // 删除
    handleRemove(file, fileList) {
      this.report.quality_reports = "";
      console.log(file);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 获取图片
    getimg(id) {
      this.fileList = [];
      qualityreports({ id: id, quality_reports: "" }).then(response => {
        if (response.data.quality_reports) {
          this.report.quality_reports = response.data.quality_reports;
          downloadimg({
            filename: response.data.quality_reports,
            appkey: "",
            sign: ""
          }).then(res => {
            // 有图片这添加到列表
            this.fileList.push({
              name: "yage",
              url: "data:image/png;base64," + res.data
            });
          });
        }
        console.log(this.fileList);
      });
    },
    onchange(file) {
      console.log(file);
    },
    qinchulist(response, file, fileList) {
      console.log(response);
      this.report.quality_reports = response.data;
          this.$message({
                  type: "success",
                  message: "上传成功!"
                });
    },
      beforeAvatarUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 1;
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 1MB!');
        }
        return isLt2M;
      }
  }
};
</script>

<style>
.v-modal {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    background: #000000;
}
</style>
